import styles from "./Header.module.css";
import cv from "../assets/cv.jpg";
import icon from "../assets/icon.jpg";
import { StatusBtton } from "./StatusButton";
import { ProgressBtton } from "./ProgressButton";
import { Form } from "./Form";

type Props = {
  isOpen: boolean;
  count: number;
  date: string;
  onPressRegist: (mail: string) => void;
  error: string;
  showTips: boolean;
  onCloseTips: () => void;
};

export const Header = (props: Props) => {
  return (
    <div className={styles.headerContainer}>
      <div className={styles.headerContent}>
        <div
          className={styles.headerImg}
          style={{ backgroundImage: `url(${cv})` }}
        />
        <div className={styles.headerRight}>
          <div
            className={styles.icon}
            style={{ backgroundImage: `url(${icon})` }}
          />
          <div className={styles.title}>
            <div className={styles.title3}>Nom</div>
            <div className={styles.title2}>About comission</div>
          </div>
          <div className={styles.buttons}>
            <StatusBtton isOpen={props.isOpen}></StatusBtton>
            <ProgressBtton count={props.count}></ProgressBtton>
          </div>
        </div>
      </div>
      <Form
        isOpen={props.isOpen}
        date={props.date}
        onPressRegist={props.onPressRegist}
        error={props.error}
        showTips={props.showTips}
        onCloseTips={props.onCloseTips}
      />
    </div>
  );
};

export default Header;
